// types
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lang: localStorage.getItem("lang") || "en",
  dir: localStorage.getItem("dir") || "ltr",
};

// ==============================|| SLICE - MENU ||============================== //

const lang_dir = createSlice({
  name: "lang_dir",
  initialState,
  reducers: {
    EN_LANG_DIR: () => {
      localStorage.setItem("lang", "en");
      localStorage.setItem("dir", "ltr");
      window.location.reload();
    },
    AR_LANG_DIR: () => {
      localStorage.setItem("lang", "ar");
      localStorage.setItem("dir", "rtl");
      window.location.reload();
    },
  },
});

export default lang_dir.reducer;

export const { EN_LANG_DIR, AR_LANG_DIR } = lang_dir.actions;
